import { render, staticRenderFns } from "./SingleImgCutting.vue?vue&type=template&id=31ee8cc1&"
import script from "./SingleImgCutting.vue?vue&type=script&lang=js&"
export * from "./SingleImgCutting.vue?vue&type=script&lang=js&"
import style0 from "./SingleImgCutting.vue?vue&type=style&index=0&id=31ee8cc1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports